

















import Vue from 'vue'
import { inIOS } from 'vtils'

export default Vue.extend({
  props: {
    top: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 强制使用 vant 的 sticky 组件
    useVant: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    isIOS: inIOS(),
    isFixed: false,
  }),

  methods: {
    handleStickyChange(isFixed: boolean) {
      this.$emit('change', isFixed)
      this.isFixed = isFixed
    },
  },
})
